import type { ClientAccessPointCandidate, ClientAvailability } from '@freedom/shared';

function clearanceRank(candidate: ClientAccessPointCandidate): number {
  if (candidate.hasLineOfSight && candidate.fresnelClearancePercent >= 60) return 2;
  if (candidate.heightTargetReachable) return 1;
  return 0;
}

export function rankAccessPointCandidates(candidates: ClientAccessPointCandidate[]): ClientAccessPointCandidate[] {
  return [...candidates].sort((left, right) => {
    const clearance = clearanceRank(right) - clearanceRank(left);
    if (clearance !== 0) return clearance;
    if (right.snrDb !== left.snrDb) return right.snrDb - left.snrDb;
    if (right.fadeMarginDb !== left.fadeMarginDb) return right.fadeMarginDb - left.fadeMarginDb;
    if (right.throughputMbps !== left.throughputMbps) return right.throughputMbps - left.throughputMbps;
    if (left.loadPercent !== right.loadPercent) return left.loadPercent - right.loadPercent;
    if (left.predictedInterferenceDbm !== right.predictedInterferenceDbm) return left.predictedInterferenceDbm - right.predictedInterferenceDbm;
    return left.distanceM - right.distanceM;
  });
}

export function classifyClientAvailability(candidate: ClientAccessPointCandidate | null): ClientAvailability {
  if (!candidate || candidate.fadeMarginDb < 0) return 'unavailable';
  if (candidate.hasLineOfSight && candidate.fresnelClearancePercent >= 60) return 'available';
  return candidate.heightTargetReachable ? 'height_required' : 'unavailable';
}
